import Base from './base'

export default class MelodyUser extends Base {
  async me() {
    return this.api.get('users.json')
  }

  async azure() {
    return this.api.get('email_clients/azure.json')
  }

  async zoom() {
    return this.api.get('profile/zoom')
  }
}
